/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LeaverInvestmentWorkflowType {
    LEAVER = 'LEAVER',
    PARTIAL_LEAVER = 'PARTIAL_LEAVER',
}
